const React = require('react');


/* eslint-disable */
module.exports = (props) => {
  return (
    <svg
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={'dB strokeCT>path ' + (props.className || '')}
    >
      <path
        d="M2.42857 1C12.6857 1 21 8.89857 21 18.6429M2.42857 9.14286C5.08074 9.14286 7.62428 10.1437 9.49964 11.9253C11.375 13.7069 12.4286 16.1233 12.4286 18.6429M3.85714 18.6429C3.85714 19.0028 3.70663 19.348 3.43872 19.6025C3.17081 19.857 2.80745 20 2.42857 20C2.04969 20 1.68633 19.857 1.41842 19.6025C1.15051 19.348 1 19.0028 1 18.6429C1 18.2829 1.15051 17.9377 1.41842 17.6832C1.68633 17.4287 2.04969 17.2857 2.42857 17.2857C2.80745 17.2857 3.17081 17.4287 3.43872 17.6832C3.70663 17.9377 3.85714 18.2829 3.85714 18.6429Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
